const Clock = () => (
  <svg viewBox='0 0 25 25'>
    <path
      fillRule='evenodd'
      d='M.204 12.482c0-6.628 5.373-12 12-12s12 5.372 12 12c0 6.627-5.373 12-12 12s-12-5.373-12-12Zm12-10.91c-6.025 0-10.909 4.885-10.909 10.91 0 6.024 4.884 10.909 10.91 10.909 6.024 0 10.908-4.884 10.908-10.91 0-6.024-4.884-10.909-10.909-10.909Z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M12.204 5.063c.301 0 .546.244.546.546v6.646l3.276 3.277a.545.545 0 0 1-.771.771l-3.437-3.436a.545.545 0 0 1-.16-.386V5.61c0-.302.245-.546.546-.546Z'
      clipRule='evenodd'
    />
  </svg>
)

export { Clock }
